import { UploadSessionState } from '@office-start/upload-types';
export function isFinished(state) {
    return (state === UploadSessionState.Completed ||
        state === UploadSessionState.Cancelled ||
        state === UploadSessionState.Failed);
}
//# sourceMappingURL=isFinished.js.map